import {
    Component,
    inject,
    Injectable,
} from '@angular/core';

import {
    MAT_DIALOG_DATA,
    MatDialog,
    MatDialogModule,
} from '@angular/material/dialog';

import {
    TranslateModule,
} from '@ngx-translate/core';

import {
    BaseDialogService,
    TilbyDialogContentComponent,
    TilbyDialogToolbarComponent,
} from '@tilby/tilby-ui-lib/components/tilby-dialog';

import {
    lastValueFrom,
} from 'rxjs';

import {
    UserActiveSessionManagerService,
} from 'src/app/core/services/user-active-session-manager.service';

export interface DemoGreetingDialogData {
    userName: string;
}

const OPERATORS = [
    { name: 'Roberto', email: 'assistenza@scloby.com', imageName: 'roberto' },
    { name: 'Simone', email: 'assistenza@scloby.com', imageName: 'simone' },
];

@Component({
    selector: 'app-demo-greeting-dialog',
    standalone: true,
    imports: [
        MatDialogModule,
        TilbyDialogContentComponent,
        TilbyDialogToolbarComponent,
        TranslateModule,
    ],
    templateUrl: './demo-greeting-dialog.component.html',
})
export class DemoGreetingDialogComponent {
    protected readonly data: DemoGreetingDialogData = inject(MAT_DIALOG_DATA);
    protected readonly operator = OPERATORS[Math.floor(Math.random() * OPERATORS.length)];
}

@Injectable({
    providedIn: 'root',
})
export class DemoGreetingDialogService extends BaseDialogService {
    private readonly dialog = inject(MatDialog);
    private readonly userActiveSession = inject(UserActiveSessionManagerService);

    /** Greets the user of a demo shop, with one of the support operators picked at random. */
    public openDialog(): Promise<void> {
        const session = this.userActiveSession.getSession();

        return lastValueFrom(this.dialog.open(DemoGreetingDialogComponent, {
            ...this.switchMobileDesktopDimensions({ width: '700px' }),
            data: { userName: session?.first_name || session?.username || '' } satisfies DemoGreetingDialogData,
        }).afterClosed());
    }
}
